// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/images/Image-upload.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sha-1 {
  border-radius: 7.714px;
  border: 0.643px solid var(--Grey-30, #E7E7E7);
  background: var(--White, #FDFDFD);
  box-shadow: 0px 0.643px 1.286px 0px rgba(16, 24, 40, 0.05);
}

.sha-2 {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.event-bg {
  position: absolute;
  width: 100%;
  height: 200px;
  top: 0;
  left: 0;
  z-index: -1;
  flex: 1 0 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 100%), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) lightgray 0px -81.325px/100% 161.191% no-repeat;
  background-size: cover !important;
  background-position: center !important;
  filter: blur(3px);
}

.accordion-details .accordion-title {
  justify-content: start !important;
  color: #FF2459;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 115%;
  gap: 6px !important;
  padding: 0;
}
.accordion-details .accordion-title svg {
  fill: #FF2459 !important;
  color: #FF2459 !important;
}
.accordion-details .accordion-content {
  font-size: 14px !important;
  padding: 0 !important;
  font-weight: 500 !important;
  line-height: 115% !important;
  color: #101010 !important;
}

.payment-details {
  width: 100% !important;
}
.payment-details .accordion-title {
  width: full;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 115%;
  gap: 6px !important;
  padding: 0;
}
.payment-details .accordion-content {
  font-size: 14px !important;
  padding: 0 !important;
  font-weight: 500 !important;
  line-height: 115% !important;
}

.custom-accordion-title {
  cursor: pointer;
}
.custom-accordion-title svg {
  flex-shrink: 0;
}

.add-btn {
  width: 88px !important;
  height: 32px !important;
  color: #FF2459 !important;
  padding: 8px 8px 8px 10px !important;
  font-size: 12px !important;
  font-weight: 500;
  border-radius: 6px !important;
  background-color: #FFF2F2 !important;
  border: 1px solid #FF2459 !important;
}

.control-btn {
  padding: 0 !important;
  border-radius: 0 !important;
}

.control-btn.disabled {
  opacity: 0.4;
  background: none !important;
  color: white !important;
}

.save-btn {
  width: 200px;
  height: 56px;
}

.hgt {
  height: calc(100vh - 72px);
}

.hgt-2 {
  height: calc(100vh - 274px);
}

.wdh {
  width: 100%;
}

@media screen and (min-width: 650px) {
  .event-bg {
    display: none;
  }
  .hgt {
    height: calc(100vh - 100px);
  }
  .hgt-2 {
    height: 100%;
  }
  .wdh {
    width: 500px;
  }
}
.custom-accordion-wrapper {
  background-color: #FDFDFD;
}
.custom-accordion-wrapper .accordion-title {
  cursor: pointer;
}
.custom-accordion-wrapper .accordion-title svg {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/routes/event-buyerflow/components/style.scss"],"names":[],"mappings":"AAAA;EACA,sBAAA;EACA,6CAAA;EACA,iCAAA;EACA,0DAAA;AACA;;AAEA;EACI,kDAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EAEA,sLAAA;EACA,iCAAA;EACA,sCAAA;EACA,iBAAA;AAAJ;;AAII;EACI,iCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;AADR;AAII;EACI,wBAAA;EACA,yBAAA;AAFR;AAKI;EACI,0BAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AAHR;;AAOA;EACI,sBAAA;AAJJ;AAMI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;AAJR;AAOI;EACI,0BAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;AALR;;AASA;EACI,eAAA;AANJ;AAQI;EACE,cAAA;AANN;;AAUA;EACI,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,oCAAA;EACA,0BAAA;EACA,gBAAA;EACA,6BAAA;EACA,oCAAA;EACA,oCAAA;AAPJ;;AAUA;EACG,qBAAA;EACA,2BAAA;AAPH;;AAUA;EACI,YAAA;EACA,2BAAA;EACA,uBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,YAAA;AAPJ;;AAUA;EACI,0BAAA;AAPJ;;AAUA;EACI,2BAAA;AAPJ;;AAUA;EACI,WAAA;AAPJ;;AAUA;EACI;IACI,aAAA;EAPN;EAUE;IACI,2BAAA;EARN;EAWE;IACI,YAAA;EATN;EAaE;IACI,YAAA;EAXN;AACF;AAeA;EACI,yBAAA;AAbJ;AAeI;EACE,eAAA;AAbN;AAeM;EACE,cAAA;AAbR","sourcesContent":[".sha-1{\nborder-radius: 7.714px;\nborder: 0.643px solid var(--Grey-30, #E7E7E7);\nbackground: var(--White, #FDFDFD);\nbox-shadow: 0px 0.643px 1.286px 0px rgba(16, 24, 40, 0.05);\n}\n\n.sha-2{\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.event-bg {\n    position: absolute;\n    width: 100%;\n    height: 200px ;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    flex: 1 0 0;\n    // background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 9.25%, rgba(255, 255, 255, 0) 70%, rgba(255, 255, 255, 0.393) 92.13%), url('/assets/images/Image-upload.svg') lightgray 0px -127.411px / 100% 171.591% no-repeat;\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.50) 100%), url('/assets/images/Image-upload.svg') lightgray 0px -81.325px / 100% 161.191% no-repeat;\n    background-size: cover !important;\n    background-position: center !important;\n    filter: blur(3px);\n}\n\n.accordion-details{\n    .accordion-title{\n        justify-content: start !important;\n        color: theme('colors.primary');\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 115%;\n        gap:6px !important;\n        padding: 0;\n    }\n\n    .accordion-title svg{\n        fill: theme('colors.primary') !important;\n        color: theme('colors.primary') !important;\n    }\n\n    .accordion-content{\n        font-size: 14px !important;\n        padding: 0 !important;\n        font-weight: 500 !important;\n        line-height: 115% !important;\n        color: theme('colors.black')  !important;\n    }\n}\n\n.payment-details{\n    width: 100% !important;\n\n    .accordion-title{\n        width: full;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 115%;\n        gap:6px !important;\n        padding: 0;\n    }\n\n    .accordion-content{\n        font-size: 14px !important;\n        padding: 0 !important;\n        font-weight: 500 !important;\n        line-height: 115% !important;\n    }\n}\n\n.custom-accordion-title {\n    cursor: pointer;\n\n    svg {\n      flex-shrink: 0;\n    }\n}\n\n.add-btn{\n    width: 88px !important;\n    height: 32px !important;\n    color:theme('colors.primary') !important;\n    padding: 8px 8px 8px 10px !important;\n    font-size: 12px !important;\n    font-weight: 500;\n    border-radius: 6px !important;\n    background-color: theme('colors.light') !important;\n    border: 1px solid theme('colors.primary') !important;\n}\n\n.control-btn{\n   padding: 0 !important;\n   border-radius: 0 !important;\n}\n\n.control-btn.disabled{\n    opacity: 0.4;\n    background: none !important;\n    color:white !important;\n}\n\n.save-btn{\n    width: 200px;\n    height: 56px;\n}\n\n.hgt{\n    height: calc(100vh - 72px);\n}\n\n.hgt-2{\n    height: calc(100vh - 274px);\n}\n\n.wdh{\n    width: 100%;\n}\n\n@media screen and (min-width: 650px) {\n    .event-bg{\n        display: none;\n    }\n\n    .hgt{\n        height: calc(100vh - 100px);\n    }\n\n    .hgt-2{\n        height: 100%;\n    }\n\n\n    .wdh{\n        width: 500px;\n    }\n\n}\n\n.custom-accordion-wrapper {\n    background-color: theme('colors.white');\n  \n    .accordion-title {\n      cursor: pointer;\n  \n      svg {\n        flex-shrink: 0;\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
